import { HR } from 'foundations-components/transitional/components/HR';
import { View } from 'foundations-components/components/View';
import AsyncUIAvatar from './AsyncUIAvatar';
import ResponderOption from './ResponderOption';
import { getAgentId, getAgentState, getAvatarUrl, getBotId, getEmail, getFirstName, getIsAssignable, getLastName } from '../operators/assignees';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UserOption = ({
  currentAssigneeId,
  currentUserId,
  option,
  showCapacityStatus
}) => {
  if (!option || !option.responder) {
    return null;
  }
  const {
    responder
  } = option;
  const user = /*#__PURE__*/_jsx(ResponderOption, {
    agentId: getAgentId(responder) || getBotId(responder),
    agentState: getAgentState(responder),
    AsyncUIAvatar: AsyncUIAvatar,
    avatar: getAvatarUrl(responder),
    currentAssigneeId: currentAssigneeId,
    email: getEmail(responder),
    firstName: getFirstName(responder),
    isAssignable: getIsAssignable(responder),
    lastName: getLastName(responder),
    responder: responder,
    showCapacityStatus: showCapacityStatus
  });
  if (currentUserId === option.value) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(View, {
        paddingInlineStart: "100",
        as: "div",
        children: user
      }), /*#__PURE__*/_jsx(HR, {
        marginBlockEnd: "250",
        marginBlockStart: "0"
      })]
    });
  }
  return user;
};
UserOption.displayName = 'UserOption';
export default UserOption;